<template>
  <div class="h-100 d-flex align-center justify-space-between">
    <!-- 👉 Footer: left content -->
    <span class="d-flex align-center">
      &copy; {{ new Date().getFullYear() }} Vector Health AI,
      All rights Reserved
    </span>
    <!-- 👉 Footer: right content -->
  </div>
</template>
